import { render, staticRenderFns } from "./productStockSelector.vue?vue&type=template&id=aeb1cf2e&scoped=true&"
import script from "./productStockSelector.vue?vue&type=script&lang=js&"
export * from "./productStockSelector.vue?vue&type=script&lang=js&"
import style0 from "./productStockSelector.vue?vue&type=style&index=0&lang=css&"
import style1 from "./productStockSelector.vue?vue&type=style&index=1&id=aeb1cf2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb1cf2e",
  null
  
)

export default component.exports